<template>
    <v-dialog :open="show" class="admin-person-info-alert" kind="confirm" @input="handleInput">
        <div slot="title"></div>
        <div slot="footer">
            <v-button size="large" @click="handleInput(false)">{{ $t('知道了') }}</v-button>
        </div>
        <div class="admin-person-info-alert-content">
            {{ $t('该手机号已关联了与本企业资质不同的其他企业，请更换手机号，或将两企业改为相同资质后再添加该手机号') }}
        </div>
    </v-dialog>
</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {};
    },
    methods: {
        handleInput(show) {
            this.$emit('update:show', show);
        }
    }
};
</script>

<style lang="less">
.admin-person-info-alert {
    .v-dialog__content {
        padding: 40px 30px;
    }
    &-content {
        width: 380px;
        font-weight: 500;
        font-size: 24px;
        line-height: 34px;
        text-align: center;
        color: #1e2330;
    }
}
</style>
